module.exports = __webpack_public_path__ + "static/media/unboared_beta.b4ec2d58.png";